export default __webpack_public_path__ + "static/media/DSC09794.5b421977.JPG";